import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from "../nest-api";

@Injectable()
export class SfrequestinboxProvider {

  private _service: string = 'attendance';
  private _model: string = 'sfrequestinbox';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getApprovalList(reqno: string, isSF6: boolean): Observable<any> {

    const _method: string = 'GET';
    const _func: string = 'getApprovalList';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof reqno !== 'undefined' && reqno !== null) _urlParams.reqno = reqno;
    if (typeof isSF6 !== 'undefined' && isSF6 !== null) _urlParams.isSF6 = isSF6;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/sfrequestinbox/sfrequestinbox.ts